import { Chip } from "@mui/material";
import { Datagrid, FunctionField, TextField, useTranslate } from "react-admin";

import { getDeviceStatusColor } from "../lib/statusColors";
import { DeviceRecord } from "../types/device";

interface DeviceDataGridProps {
  showLocationColumn?: boolean;
}

export const DeviceDataGrid = ({ showLocationColumn = true }: DeviceDataGridProps) => {
  const translate = useTranslate();

  return (
    <Datagrid rowClick={"show"} bulkActionButtons={false}>
      <TextField source="name" label={translate("tabletName")} />
      <FunctionField
        source="manufacturer"
        label={translate("manufacturerModel")}
        render={(record: DeviceRecord) => [record.manufacturer, record.model].filter(Boolean).join(" ")}
      />
      <TextField source="osVersion" label={translate("osVersion")} />
      {showLocationColumn && <TextField source="location.name" label={translate("locations")} />}
      <TextField source="appVersion" label={translate("appVersion")} />
      <FunctionField
        label={translate("status")}
        render={(record: DeviceRecord) => (
          <Chip
            label={
              record.unenrolledAt
                ? translate("deviceEnrollment.unenroll.status")
                : translate(`deviceStatus.${record.status.toUpperCase()}`)
            }
            color={record.unenrolledAt ? "default" : getDeviceStatusColor(record.status)}
            size="small"
            data-testid="device-status"
          />
        )}
      />
    </Datagrid>
  );
};
